

import 'babel-polyfill'
import Vue from 'vue'
import FastClick from 'fastclick'
import router from './router'
import App from './App'
import ToastPlugin from 'vux/src/plugins/toast/index.js'
import LoadingPlugin from 'vux/src/plugins/loading/index.js'

import axios from 'axios'
import cgi from './cgi'
import functions from './utils/function'
import Message from '@/components/Message'
import qs from 'qs'
const isDev = process.env.NODE_ENV === 'development'
axios.defaults.withCredentials = true
axios.defaults.xsrfCookieName = 'cloudsafetoken'
axios.defaults.xsrfHeaderName = 'X-CRSF-TOKEN'

Vue.prototype.$cgi = cgi
Vue.prototype.$Message = Message
Vue.prototype.$getCookie = functions.getCookie

Vue.use(ToastPlugin)
Vue.use(LoadingPlugin)
FastClick.attach(document.body)
Vue.config.productionTip = isDev
Vue.prototype.$isDev = isDev


let beacon = new BeaconAction({
appkey: 'JS08SANX3T6GJ6', // 系统或项目id, 必填
versionCode: '1.0.1', //项目版本,选填
channelID: 'channel', //渠道,选填
openid: 'openid', // 用户id, 选填
delay: 0, // 普通事件延迟上报时间(单位毫秒), 默认3000(3秒),选填
sessionDuration: 60 * 1000,// session变更的时间间隔, 一个用户持续30分钟(默认值)没有任何上报则算另一次 session,每变更一次session上报一次启动事件(rqd_applaunched),使用毫秒(ms),最小值30秒,选填
})
Vue.prototype.beacon = beacon


let lrsmBeacon = new BeaconAction({
appkey: '0WEB0KYEDG4JFF6T', // 系统或项目id, 必填
channelID: 'channel', //渠道,选填
openid: 'openid', // 用户id, 选填
delay: 0, // 普通事件延迟上报时间(单位毫秒), 默认3000(3秒),选填
sessionDuration: 60 * 1000,// session变更的时间间隔, 一个用户持续30分钟(默认值)没有任何上报则算另一次 session,每变更一次session上报一次启动事件(rqd_applaunched),使用毫秒(ms),最小值30秒,选填
})
Vue.prototype.lrsmBeacon = lrsmBeacon


let lrsmReport = eventName => {
axios({
url: 'https://bma.urlsec.qq.com/rw-online/ext',
method: 'post',
withCredentials: false,
data: {
Action: 'InsertEvent',
RequestId: (Math.floor(Math.random() * 100000)) + '',
EventName: eventName,
Origin: 'QQ'
}
})
}
Vue.prototype.lrsmReport = lrsmReport


let {src} = qs.parse(location.search.slice(1))
Vue.prototype.$http = function(url, options = {}) {
if(typeof url === 'string') {
options.url = url
} else {
options = url
}

if(!options.params) {
options.params = {src: src}
}else if(!options.params.src) {
options.params.src = src
}

return axios(options).then(resp => {
const {reCode, data} = resp.data

if(reCode === -206 || reCode === -207 || reCode === -208) {
location.href = `/wechat/urlcomplain#/urlcomplain/error?code=${reCode}&data=${data}`
}

return resp
})
}


/* eslint-disable no-new */
new Vue({
router,
render: h => h(App)
}).$mount('#app-box')



// WEBPACK FOOTER //
// ./src/main.js